import { map, tap } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  BaselinkService,
  BaserubrikenService,
  LinkConfigEntries,
  LinkConfigEntry,
  RubrikConfigEntry
} from '../base-api';
import RubrikEnum = RubrikConfigEntry.RubrikEnum;


@Injectable()
export class AppCustomConfigService implements OnDestroy {

  linkConfigSubject = new BehaviorSubject<LinkConfigEntry[]>([]);

  constructor(private linkService: BaselinkService,
              private rubrikService: BaserubrikenService) {
    this.reloadLinkConfigs();
  }

  getLinkConfig(id: string): Observable<LinkConfigEntry> {
    return this.linkService.getLinkConfigEntry(id);
  }

  getLinkConfigs(): Observable<Array<LinkConfigEntry>> {
    return this.linkService.getLinkConfig().pipe(map(data => data.entries));
  }

  createLinkConfig(entry: LinkConfigEntry): Observable<LinkConfigEntry> {
    return this.linkService.createLinkConfigEntry(entry).pipe(tap(() => this.reloadLinkConfigs()));
  }

  updateLinkConfig(entry: LinkConfigEntry): Observable<LinkConfigEntry> {
    return this.linkService.updateLinkConfigEntry(entry.id, entry).pipe(tap(() => this.reloadLinkConfigs()));
  }

  updateLinkConfigs(entries: Array<LinkConfigEntry>): Observable<LinkConfigEntries> {
    const links: LinkConfigEntries = { entries: entries };
    return this.linkService.updateLinkConfigEntries(links).pipe(tap(() => this.reloadLinkConfigs()));
  }

  deleteLinkConfig(entry: LinkConfigEntry): Observable<{}> {
    return this.linkService.removeLinkConfigEntry(entry.id).pipe(tap(() => this.reloadLinkConfigs()));
  }

  getRubrikConfigs(): Observable<Array<RubrikConfigEntry>> {
    return this.rubrikService.getRubrikConfig().pipe(map(data => data.entries));
  }

  getRubrikComponents(rubrik: RubrikEnum): Observable<Array<string>> {
    return this.rubrikService.getAvailableRubrikComponents(rubrik);
  }

  updateRubrikConfig(rubrik: RubrikConfigEntry): Observable<RubrikConfigEntry> {
    return this.rubrikService.addRubrikConfigEntry(rubrik);
  }

  reloadLinkConfigs() {
    this.getLinkConfigs().subscribe(links => this.linkConfigSubject.next(links));
  }

  ngOnDestroy(): void {
    if (this.linkConfigSubject) {
      this.linkConfigSubject.unsubscribe();
    }
  }
}
